import React, { memo } from 'react';
import StatusSelector, {
    StatusSelectorOptions,
} from 'components/SharedComponents/StatusSelector/StatusSelector';
import { isEqual } from 'lodash';
import { PayComponentMapping } from 'routes/Mappings/components/PayComponentsTable/helpers/definitions';

type Props = {
    selectedValue?: PayComponentMapping | null;
    handleChange: (event: StatusSelectorOptions<number>) => void;
    choices: PayComponentMapping[];
};

function MappingValueSelector({
    selectedValue = null,
    choices,
    handleChange,
}: Props) {
    return (
        <StatusSelector<number>
            width="full-width"
            variant="outlined"
            options={choices.map((choice) => ({
                label: choice.value,
                value: choice.destinationId,
                color: 'primary',
            }))}
            tooltipValue=""
            defaultOption={{
                label: selectedValue?.value ?? '',
                value: selectedValue?.destinationId ?? 0,
                color: 'primary',
            }}
            onChange={(e) => handleChange(e)}
        />
    );
}

export default memo(MappingValueSelector, isEqual);
